<template lang="pug">
div
</template>

<script setup>
import { useUrlModalTrigger } from '@/composables/ui/useUrlModalTrigger'
import { MODAL_INTENT } from '@/utils/urlModal'

definePageMeta({
  middleware: 'guest',
})

// 大廳的註冊入口：畫面沿用父層 / 大廳（pages/index.vue 的 IndexOriginal），本頁只負責開窗。
// 降為 / 的子路由才不會在 / ↔ /register 之間換掉頁面元件而整包 remount 大廳（TI-15592 §1 衍生）
// 開窗、未開放註冊 fallback、?error= 守門、公告延後旗標統一由 composable 處理
// 規格：spec/JT-1784716920_url-modal-trigger-announcement-deferral.md
useUrlModalTrigger(MODAL_INTENT.REGISTER)
</script>

<style lang="scss" scoped></style>
